// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function … --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeObjectFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
// Note: The following attributes are automatically provided by the experiment provider
// and do not need to be passed as parameters: isEnterprise, subscriptionTier, userEmail
export const useAsiKnowledgeReadConfigVariation = makeObjectFlagValueHook('asi-knowledge-read-config');
//# sourceMappingURL=useAsiKnowledgeReadConfigVariation.js.map